import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Context as IsMobileContext } from '../../../Context/IsMobileContext';
import { sectionsIds } from '../sections';
import { Spacings } from '../../../../styleConstants';
import EventsContainer from './EventsContainer';
import SectionContainer from '../SectionContainer';

const SummitEvents = ({ headerRefs }) => {
  const isMobileDevice = useContext(IsMobileContext);
  const staticTexts = useSelector(({ summit }) => summit.staticTexts);
  return (
    <SectionContainer
      title="Events"
      color="#FFB800"
      sectionId={sectionsIds.events}
      headerRefs={headerRefs}
      contentMarginTop={isMobileDevice ? Spacings.SPACING_10B : '120px'}
      quote={staticTexts.eventsHeader || ''}
      description={staticTexts.eventsDesc || ''}
    >
      <EventsContainer />
    </SectionContainer>
  );
};

SummitEvents.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitEvents;
